let currentisRtl = false

export const setIsRtl = (newIsRtl) => {
  currentisRtl = newIsRtl
}

export const isRtl = () => {
  return currentisRtl
}
